




















import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import AppIcon from '~/components/partials/App/AppIcon.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import { DynamicPartsYouTube } from '~/types/modules/contents';

export default defineComponent({
  components: {
    AppIcon,
    AppImage,
  },
  props: {
    item: {
      type: Object as PropType<DynamicPartsYouTube>,
      required: true,
    },
  },
  setup() {
    const isThumbnail = ref(true);
    return {
      isThumbnail,
    };
  },
});
